import { useEffect, useRef, useState } from 'react';
import { Card, CardBody } from '../ui/Card.jsx';
import HeadingOne from '../ui/HeadingOne.jsx';
import { Col, Row } from '../ui/Layout.jsx';
import MiniCard from '../ui/MiniCard.jsx';
import Button from '../ui/Button.jsx';

const WhatDo = ({ heading_img, heading, button, items, fn }) => {
    const [selected, setSelected] = useState(null);

    return (
        <div className="component-whatdo">
            <div className="row">
                <HeadingOne className="col" image={heading_img} heading={heading} />
            </div>
            <Card>
                <CardBody className="!py-20">
                    <div className="grid grid-cols-3">
                        {items?.map((item, index) => (
                            <div className="col-span-3 lg:col-span-1">
                                <div className={'cursor-pointer rounded-[28px] p-12 ' + (selected===index ? 'bg-cyan-700 ' : 'bg-transparent')} onClick={() => setSelected(index)}>
                                    <div className={'flex flex-col justify-between items-center rounded-[20px] h-72 p-4 border border-white/20'}>
                                        <div className="size-36 rounded-full overflow-hidden mx-auto">
                                            <img src={item.image} alt={item.text} className="h-full w-full object-cover object-top" />
                                        </div>
                                        <div className="h-18 flex items-center font-bold text-center">{item.text}</div>
                                    </div>
                                    <div className={"flex justify-center mt-8 " + (selected===index ? '' : 'hidden')}>
                                        <Button {...item.button} onClick={() => fn.handleAction(item.button.action)} />
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </CardBody>
            </Card>
        </div>
    );
};

export default WhatDo;
